import { privateRequest, publicRequest } from "../axios";

const ENDPOINTS = {
  INVITE_USER: "/organizations/invite",
  FETCH_INVITATIONS: "/organizations/invitations",
  UPDATE_INVITATION: (id: string | number) => `/organizations/invitations/${id}`,
  DELETE_INVITATION: (id: string | number) => `/organizations/invitations/${id}`,
};

export const inviteUserAPI = async (email: string, role: string) => {
  try {
    const response = await privateRequest.post(ENDPOINTS.INVITE_USER, {
      email,
      role,
    });
    return response.data;
  } catch (error) {
    console.error("Error inviting user:", error);
    throw error;
  }
};

export const fetchInvitationsAPI = async (params: {
  search?: string | null;
  page?: number;
  limit?: number;
}) => {
  try {
    const response = await privateRequest.get(ENDPOINTS.FETCH_INVITATIONS, {
      params,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching invitations:", error);
    throw error;
  }
};

export const updateInvitationAPI = async (id: string | number, role: string) => {
  try {
    const response = await privateRequest.put(
      ENDPOINTS.UPDATE_INVITATION(id),
      null,
      {
        params: { role },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error updating invitation:", error);
    throw error;
  }
};

export const deleteInvitationAPI = async (id: string | number) => {
  try {
    const response = await privateRequest.delete(ENDPOINTS.DELETE_INVITATION(id));
    return response.data;
  } catch (error) {
    console.error("Error deleting invitation:", error);
    throw error;
  }
};

export const acceptInvitationAPI = async (payload: {
  token: string;
  name: string;
  mobileNo: string;
  password?: string;
}) => {
  try {
    const response = await publicRequest.post("/organizations/accept-invite", payload);
    return response.data;
  } catch (error) {
    console.error("Error accepting invitation:", error);
    throw error;
  }
};

const InvitationService = {
  inviteUser: inviteUserAPI,
  fetchInvitations: fetchInvitationsAPI,
  updateInvitation: updateInvitationAPI,
  deleteInvitation: deleteInvitationAPI,
  acceptInvitation: acceptInvitationAPI,
};

export default InvitationService;
